import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BaseService } from "@app/shared/services/base.service";
import { DestinationCommunicationService } from "@app/shared/services/destination-communication.service";
import { FlightService } from "@app/shared/services/flight.service";
import { environment } from "environments/environment";

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
	clientName = "";
	currentYear: number = new Date().getFullYear();
	inLoginPage: boolean = false;
	showDestinationPopup: boolean = false;
	selectedDestination: any = null;

	RubriquesList4winds=[
		{
			title:"FWT",
			link:"https://fourwindstravels.dz/four-winds-travels/"
		},
		{
			title:"Touring Club d’Algérie",
			link:"https://fourwindstravels.dz/touring-club-algerie/"
		},
		{
			title:"Agences",
			link:"https://fourwindstravels.dz/agences/"
		},
		{
			title:"Engagements",
			link:"https://fourwindstravels.dz/engagements/"
		},
		{
			title:"Programme 2024",
			link:"https://fourwindstravels.dz/programme-2024/"
		},
		{
			title:"Corporate",
			link:"https://fourwindstravels.dz/corporate/"
		},
		{
			title:"Destinations DZ",
			link:"https://fourwindstravels.dz/destinations-dz/"
		},
		{
			title:"Contact",
			link:"https://fourwindstravels.dz/contact/"
		}
	]

	AgencesList4winds=[
		{
			title:"Agence Les Vergers - British Airways et Iberia",
			link:"https://www.google.com/maps/place/Four+winds+travels+Direction+g%C3%A9n%C3%A9rale,+%D8%A7%D9%84%D8%AC%D9%87%D8%A7%D8%AA+%D8%A7%D9%84%D8%A7%D8%B1%D8%A8%D8%B9+%D9%84%D9%84%D8%A3%D8%B3%D9%81%D8%A7%D8%B1+%2FFWT%E2%80%AD/@36.7775063,2.982851,13z/data=!4m10!1m2!2m1!1sFour+Winds+Travels!3m6!1s0x128fad95cd572a59:0xd63552b5e1d38c8a!8m2!3d36.7287644!4d3.0573992!15sChJGb3VyIFdpbmRzIFRyYXZlbHNaFCISZm91ciB3aW5kcyB0cmF2ZWxzkgELdG91cl9hZ2VuY3ngAQA!16s%2Fg%2F11l1mdjjr3?entry=ttu"
		},
		{
			title:"Agence Les Vergers - Transavia",
			link:"https://www.google.com/maps/place/Four+winds+travels+Direction+g%C3%A9n%C3%A9rale,+%D8%A7%D9%84%D8%AC%D9%87%D8%A7%D8%AA+%D8%A7%D9%84%D8%A7%D8%B1%D8%A8%D8%B9+%D9%84%D9%84%D8%A3%D8%B3%D9%81%D8%A7%D8%B1+%2FFWT%E2%80%AD/@36.7775063,2.982851,13z/data=!4m10!1m2!2m1!1sFour+Winds+Travels!3m6!1s0x128fad95cd572a59:0xd63552b5e1d38c8a!8m2!3d36.7287644!4d3.0573992!15sChJGb3VyIFdpbmRzIFRyYXZlbHNaFCISZm91ciB3aW5kcyB0cmF2ZWxzkgELdG91cl9hZ2VuY3ngAQA!16s%2Fg%2F11l1mdjjr3?entry=ttu"
		},
		{
			title:"Agence Pasteur",
			link:"https://www.google.com/maps/place/Four+Winds+Travels/@36.7775063,2.982851,13z/data=!4m10!1m2!2m1!1sFour+Winds+Travels!3m6!1s0x128fb2587dcd99f5:0x9dd0a989ee815805!8m2!3d36.7737169!4d3.058512!15sChJGb3VyIFdpbmRzIFRyYXZlbHOSAQt0b3VyX2FnZW5jeeABAA!16s%2Fg%2F11ggsg1khb?entry=ttu"
		},
		{
			title:"Agence Abane Ramdane",
			link:"https://www.google.com/maps/place/Four+Winds+Travels/@36.7775063,2.982851,13z/data=!4m10!1m2!2m1!1sFour+Winds+Travels!3m6!1s0x128fb2f85f1a69e9:0xfbb060897fc0268b!8m2!3d36.7775063!4d3.0590687!15sChJGb3VyIFdpbmRzIFRyYXZlbHOSAQ10cmF2ZWxfYWdlbmN54AEA!16s%2Fg%2F1tk5qh22?entry=ttu"
		},
		{
			title:"Agence Mennani",
			link:"https://www.google.com/maps/place/AGENCE+FOUR+WINDS+TRAVEL/@36.7775063,2.982851,13z/data=!4m10!1m2!2m1!1sFour+Winds+Travels!3m6!1s0x128fb3637900c4f3:0x7c373e79329203a2!8m2!3d36.7612609!4d3.0505441!15sChJGb3VyIFdpbmRzIFRyYXZlbHOSAQt0b3VyX2FnZW5jeeABAA!16s%2Fg%2F11hz2dm9f_?entry=ttu"
		},
		{
			title:"Agence Oran",
			link:"https://maps.app.goo.gl/rpoYYVe4HwY3nght8"
		},
		{
			title:"Agence Ghardaia",
			link : "https://maps.app.goo.gl/EiuuYWuTQDzKqRnT6"
		}

	]

	airlinesList4winds=[
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/10/air-canada-logo-black-and-white-1024x343.png",
			alt : "Air Canada",
			link:"https://fourwindstravels.dz/compagnies/air-canada"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2024/06/British-2.png",
			alt : "British Airways",
			link:"https://fourwindstravels.dz/compagnies/british-airways"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/10/iberia.webp",
			alt : "Iberia",
			link:"https://fourwindstravels.dz/compagnies/iberia"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/11/Design-sans-titre-e1700059644831.png",
			alt : "nouvlair",
			link:"https://fourwindstravels.dz/compagnies/nouvel-air"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/10/Transavia_logo_white-1024x200.png",
			alt : "Transavia",
			link:"https://fourwindstravels.dz/compagnies/transavia"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/11/Design-sans-titre-1-e1700060068437.png",
			alt : "turkish airlines",
			link:"https://fourwindstravels.dz/compagnies/turkish-airlines"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/10/logo-volotea.png",
			alt : "volotea",
			link:"https://fourwindstravels.dz/compagnies/volotea"
		},
		{
			src:"https://fourwindstravels.dz/wp-content/uploads/2023/10/Vueling.webp",
			alt : "Vueling",
			link:"https://fourwindstravels.dz/compagnies/vueling"
		}
	]

	constructor(
		public baseService: BaseService, 
		private router: Router,
		private destinationCommunicationService: DestinationCommunicationService,
		private flightService: FlightService
	) {
		this.clientName = environment.clientDisplayName.toUpperCase();
		if (document.location.href.includes("login")) {
			this.inLoginPage = true;
		}
	}

	// Destination data
	destinations = {
		'Oran': {
			name: 'ORAN',
			country: 'ALGERIA',
			description: 'ORAN_DESCRIPTION',
			image: '/assets/images/destination/orn.jpg',
			features: ['BEACHES_FEATURE', 'HISTORIC_SITES_FEATURE', 'MEDITERRANEAN_CLIMATE_FEATURE', 'SEAFOOD_CUISINE_FEATURE']
		},
		'Dubai': {
			name: 'DUBAI',
			country: 'UNITED_ARAB_EMIRATES',
			description: 'DUBAI_DESCRIPTION',
			image: '/assets/images/destination/dubai.jpg',
			features: ['BURJ_KHALIFA_FEATURE', 'SHOPPING_MALLS_FEATURE', 'DESERT_SAFARI_FEATURE', 'LUXURY_HOTELS_FEATURE']
		},
		'Paris': {
			name: 'PARIS',
			country: 'FRANCE',
			description: 'PARIS_DESCRIPTION',
			image: '/assets/images/destination/par.jpg',
			features: ['EIFFEL_TOWER_FEATURE', 'LOUVRE_MUSEUM_FEATURE', 'CHAMPS_ELYSEES_FEATURE', 'FRENCH_CUISINE_FEATURE']
		},
		'Sidi Bou Said': {
			name: 'Tunis',
			country: 'TUNISIA',
			description: 'SIDI_BOU_SAID_DESCRIPTION',
			image: '/assets/images/destination/sidi.jpg',
			features: ['BLUE_WHITE_ARCHITECTURE_FEATURE', 'MEDITERRANEAN_VIEWS_FEATURE', 'ART_GALLERIES_FEATURE', 'TRADITIONAL_CAFES_FEATURE']
		},
		'Bali': {
			name: 'BALI',
			country: 'INDONESIA',
			description: 'BALI_DESCRIPTION',
			image: '/assets/images/destination/bali.jpg',
			features: ['TROPICAL_BEACHES_FEATURE', 'ANCIENT_TEMPLES_FEATURE', 'RICE_TERRACES_FEATURE', 'BALINESE_CULTURE_FEATURE']
		},
		'Antalya': {
			name: 'ANTALYA',
			country: 'TURKEY',
			description: 'ANTALYA_DESCRIPTION',
			image: '/assets/images/destination/turkey.jpg',
			features: ['TURKISH_RIVIERA_FEATURE', 'HISTORIC_SITES_ANTALYA_FEATURE', 'BEACH_RESORTS_FEATURE', 'TURKISH_CUISINE_FEATURE']
		}
	};



	ngOnInit() {
		this.initCarousel();
	}

	initCarousel() {
		setTimeout(() => {
			const carousel = document.querySelector('.destinations-carousel') as HTMLElement;
			const prevBtn = document.querySelector('.prev-btn') as HTMLButtonElement;
			const nextBtn = document.querySelector('.next-btn') as HTMLButtonElement;
			const dots = document.querySelectorAll('.carousel-dots .dot');

			if (!carousel || !prevBtn || !nextBtn) return;

			const cardWidth = 340 + 24; // card width + gap
			let currentIndex = 0;
			const totalCards = carousel.querySelectorAll('.destination-card').length;
			const visibleCards = Math.floor(carousel.clientWidth / cardWidth) || 1;
			const maxIndex = totalCards - visibleCards;

			const updateDots = (index: number) => {
				dots.forEach((dot, i) => {
					dot.classList.toggle('active', i === index);
				});
			};

			const scrollTo = (index: number) => {
				currentIndex = Math.max(0, Math.min(index, maxIndex));
				carousel.scrollTo({ left: currentIndex * cardWidth, behavior: 'smooth' });
				updateDots(currentIndex);
			};

			prevBtn.addEventListener('click', () => scrollTo(currentIndex - 1));
			nextBtn.addEventListener('click', () => scrollTo(currentIndex + 1));

			dots.forEach((dot, i) => {
				dot.addEventListener('click', () => scrollTo(i));
			});

			// Sync dots on manual scroll
			carousel.addEventListener('scroll', () => {
				const index = Math.round(carousel.scrollLeft / cardWidth);
				updateDots(index);
				currentIndex = index;
			});
		}, 300);
	}

	isArabic() {
		return this.baseService.isArabic();
	}

	goToTop() {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}

	setLanguage(lang: string) {
		this.baseService.setLanguage(lang);
	}

	// Popup methods
	showDestinationInfo(destinationName: string) {
		this.selectedDestination = this.destinations[destinationName];
		this.showDestinationPopup = true;
		document.body.style.overflow = 'hidden'; // Prevent background scroll
	}

	closeDestinationPopup() {
		this.showDestinationPopup = false;
		this.selectedDestination = null;
		document.body.style.overflow = 'auto'; // Restore background scroll
	}

	// Navigate to destination 
	navigateToDestination(destination: string) {
		this.closeDestinationPopup();
		
		// Check if current language is Arabic
		const isArabic = this.baseService.isArabic();
		
		// Map destinations to their proper display format with IATA codes
		const destinationDisplayMap: { [key: string]: { display: string, city: string, country: string, iata: string } } = {};
		
		if (isArabic) {
			// Arabic names
			destinationDisplayMap['ORAN'] = { display: 'وهران (ORN)', city: 'وهران', country: 'الجزائر', iata: 'ORN' };
			destinationDisplayMap['Oran'] = { display: 'وهران (ORN)', city: 'وهران', country: 'الجزائر', iata: 'ORN' };
			destinationDisplayMap['PARIS'] = { display: 'باريس (PAR)', city: 'باريس', country: 'فرنسا', iata: 'PAR' };
			destinationDisplayMap['Paris'] = { display: 'باريس (PAR)', city: 'باريس', country: 'فرنسا', iata: 'PAR' };
			destinationDisplayMap['BALI'] = { display: 'دينباسار بالي (DPS)', city: 'دينباسار بالي', country: 'إندونيسيا', iata: 'DPS' };
			destinationDisplayMap['Bali'] = { display: 'دينباسار بالي (DPS)', city: 'دينباسار بالي', country: 'إندونيسيا', iata: 'DPS' };
			destinationDisplayMap['DUBAI'] = { display: 'دبي (DXB)', city: 'دبي', country: 'الإمارات العربية المتحدة', iata: 'DXB' };
			destinationDisplayMap['Dubai'] = { display: 'دبي (DXB)', city: 'دبي', country: 'الإمارات العربية المتحدة', iata: 'DXB' };
			destinationDisplayMap['SIDI BOU SAID'] = { display: 'تونس (TUN)', city: 'تونس', country: 'تونس', iata: 'TUN' };
			destinationDisplayMap['Sidi Bou Said'] = { display: 'تونس (TUN)', city: 'تونس', country: 'تونس', iata: 'TUN' };
			destinationDisplayMap['TUNIS'] = { display: 'تونس (TUN)', city: 'تونس', country: 'تونس', iata: 'TUN' };
			destinationDisplayMap['Tunis'] = { display: 'تونس (TUN)', city: 'تونس', country: 'تونس', iata: 'TUN' };
			destinationDisplayMap['ANTALYA'] = { display: 'أنطاليا (AYT)', city: 'أنطاليا', country: 'تركيا', iata: 'AYT' };
			destinationDisplayMap['Antalya'] = { display: 'أنطاليا (AYT)', city: 'أنطاليا', country: 'تركيا', iata: 'AYT' };
		} else {
			// English/French names
			destinationDisplayMap['ORAN'] = { display: 'Oran (ORN)', city: 'Oran', country: 'Algeria', iata: 'ORN' };
			destinationDisplayMap['Oran'] = { display: 'Oran (ORN)', city: 'Oran', country: 'Algeria', iata: 'ORN' };
			destinationDisplayMap['PARIS'] = { display: 'Paris (PAR)', city: 'Paris', country: 'France', iata: 'PAR' };
			destinationDisplayMap['Paris'] = { display: 'Paris (PAR)', city: 'Paris', country: 'France', iata: 'PAR' };
			destinationDisplayMap['BALI'] = { display: 'Denpasar Bali (DPS)', city: 'Denpasar', country: 'Indonesia', iata: 'DPS' };
			destinationDisplayMap['Bali'] = { display: 'Denpasar Bali (DPS)', city: 'Denpasar', country: 'Indonesia', iata: 'DPS' };
			destinationDisplayMap['DUBAI'] = { display: 'Dubai (DXB)', city: 'Dubai', country: 'United Arab Emirates', iata: 'DXB' };
			destinationDisplayMap['Dubai'] = { display: 'Dubai (DXB)', city: 'Dubai', country: 'United Arab Emirates', iata: 'DXB' };
			destinationDisplayMap['SIDI BOU SAID'] = { display: 'Tunis (TUN)', city: 'Tunis', country: 'Tunisia', iata: 'TUN' };
			destinationDisplayMap['Sidi Bou Said'] = { display: 'Tunis (TUN)', city: 'Tunis', country: 'Tunisia', iata: 'TUN' };
			destinationDisplayMap['TUNIS'] = { display: 'Tunis (TUN)', city: 'Tunis', country: 'Tunisia', iata: 'TUN' };
			destinationDisplayMap['Tunis'] = { display: 'Tunis (TUN)', city: 'Tunis', country: 'Tunisia', iata: 'TUN' };
			destinationDisplayMap['ANTALYA'] = { display: 'Antalya (AYT)', city: 'Antalya', country: 'Turkey', iata: 'AYT' };
			destinationDisplayMap['Antalya'] = { display: 'Antalya (AYT)', city: 'Antalya', country: 'Turkey', iata: 'AYT' };
		}
		
		const destinationData = destinationDisplayMap[destination];
		if (!destinationData) {
			// Fallback for unknown destinations
			this.destinationCommunicationService.setSelectedDestination({
				name: destination,
				city_name: destination,
				country_name: '',
				iata: '',
				display: destination
			});
		} else {
			// Set the destination with complete data
			this.destinationCommunicationService.setSelectedDestination({
				name: destinationData.display,
				city_name: destinationData.city,
				country_name: destinationData.country,
				iata: destinationData.iata,
				display: destinationData.display
			});
		}
		
		// Navigate to search page
		this.router.navigate(['/']);
		
		// Wait for page to load then scroll to top
		setTimeout(() => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}, 100);
	}

}
